import React, { useEffect, useState } from 'react';

export default function LandingNavigation({ onLogin }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 40);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  const close = () => setOpen(false);
  return (
    <>
      <div className="dl-scroll-progress" aria-hidden="true"><span /></div>
      <nav className={`dl-nav ${scrolled ? 'is-scrolled' : ''}`} aria-label="Główna nawigacja">
        <a className="dl-brand" href="#top" onClick={close} aria-label="VROOM — strona główna">
          <img src="/assests/Logotyp.png" alt="" />
          <span>VROOM</span><i>.</i>
        </a>
        <button className={`dl-menu-toggle ${open ? 'is-open' : ''}`} type="button" onClick={() => setOpen((value) => !value)} aria-expanded={open} aria-label="Otwórz menu">
          <span /><span />
        </button>
        <div className={`dl-nav-links ${open ? 'is-open' : ''}`}>
          <a href="#experience" onClick={close}>Aplikacja</a>
          <a href="#film" onClick={close}>Film</a>
          <a href="#ranking" onClick={close}>Ranking</a>
          <a href="#news" onClick={close}>Aktualności</a>
          {process.env.REACT_APP_WEB_SOCIAL_ENABLED !== 'false' && <a href="/social" onClick={close}>Społeczność</a>}
          <a href="https://shop.v-room.app" onClick={close}>Sklep</a>
          <button type="button" className="dl-nav-login" onClick={() => { close(); onLogin(); }}>Zaloguj się</button>
          <a className="dl-nav-cta dl-magnetic" href="#join" onClick={close}>Dołącz do VROOM</a>
        </div>
      </nav>
    </>
  );
}
